import { h, Host } from "@stencil/core";
import getSuggestionHighlight from "./get-suggestion-highlight";
export class AutosuggestItem {
    constructor() {
        this.input = "";
        this.text = "";
        this.subline = "";
        this.image = "";
        this.slim = false;
    }
    render() {
        const baseClass = "ux-autosuggest-item";
        const { text, subline, image, input } = this;
        // @ts-expect-error Check for typing
        const [highlight, remaining] = getSuggestionHighlight(input, text);
        return (h(Host, { key: '70776f244939074760eeb17583c1a77e427f37f7', class: {
                [baseClass]: true,
                [`${baseClass}--slim`]: this.slim
            } }, image !== "" && h("div", { key: 'e99fbec91666f8aef4f0ff1592c7a4e1ee5cc455', class: `${baseClass}__image`, style: { backgroundImage: `url(${image})` } }), h("div", { key: '2cea153569f26a1b6a9b755c4212f7610f4376e3', class: {
                [`${baseClass}__text-container`]: true,
                [`${baseClass}__text-container--slim`]: this.slim
            } }, h("div", { key: 'f1336fba4f51099d040560eed80dc68b38a556d0', class: `${baseClass}__text` }, h("span", { key: '64cf4ba41b0f8b82e2980c25ab350fd443dcc13a', class: `${baseClass}__highlight` }, highlight), remaining), !this.slim && h("div", { key: '8868b9949da1915f5e4ec5e1595a343f4d76a6c6', class: `${baseClass}__subline ux-text-tiny ux-text-tiny--bold` }, subline))));
    }
    static get is() { return "ux-autosuggest-item"; }
    static get originalStyleUrls() {
        return {
            "$": ["autosuggest-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["autosuggest-item.css"]
        };
    }
    static get properties() {
        return {
            "input": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "search query that will be highlighted in the text"
                },
                "attribute": "input",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "text": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "suggestion text that matches the input"
                },
                "attribute": "text",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "subline": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "subline below the text"
                },
                "attribute": "subline",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "image": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "optional image URL"
                },
                "attribute": "image",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "slim": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "if set, the suggestion item will be slim, without a subline"
                },
                "attribute": "slim",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
}
//# sourceMappingURL=autosuggest-item.js.map
